import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { TeamTaskReportComponent } from './team-task-report/team-task-report.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {
      path:'',
      children:[
        { path:'' , redirectTo:'list' , pathMatch:'full'},
        {
          path:'list',component:ListComponent
        },
        {
          path:'add',component:AddComponent
        },
        {
          path:'view/:id',component:ViewComponent
        },
        {
          path:'edit/:id',component:AddComponent
        },
        {
          path:'team-reports',component:TeamTaskReportComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','HR'] }
        },
        {
          path:'', 
          loadChildren : () => import('./emp-attendence/emp-attendence.module').then(m => m.EmpAttendenceModule) 
        }
      ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeCrudRoutingModule { }
